import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { firstValueFrom, Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';
import { MediaMatcher } from "@angular/cdk/layout";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { TutorialService } from "src/app/features/ui/organisms/tutorial/services/tutorial.service";
import { SignalUser } from "src/app/features/shared/models/SignalUser/SignalUser";
import { NotificationsToastService } from "src/app/features/shared/services/Notifications-Toast.service";
import { SignalUserService } from "src/app/features/shared/services/ServiceCatalogEncapsulators/Signal-User.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { SignalRService } from "src/app/features/shared/services/Signal-R.service";
import { EnumAlarmCategoriesColors, EnumAlarmCategoriesIcons, EnumAlarmCategoriesValues, EnumAlarmCategory } from "src/app/features/shared/helpers/enums/EnumAlarmCategories";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";
import { environment } from "src/environments/environment";
import { EnumLocationCategories } from "src/app/features/shared/helpers/enums/EnumLocationCategories";
import { AllowedDTO } from "src/app/features/pages/maps/utils/models/allowedDTO";
import { EstatusJSON } from "src/app/features/shared/models/EstatusJSON";
import { EnumPanelGPSTabTypes } from "../../../../enums/EnumPanelGPSTabTypes";
import { LayerDTO } from "../../../../models/LayerDTO";
import { LocationCategoryDTO } from "../../../../models/LocationCategoryDTO";
import { LocationDTO } from "../../../../models/LocationDTO";
import { StatusFlag } from "../../../../models/StatusFlag";
import { FilterMapService } from "../../../../services/Filter-Map.service";
import { LocationsMapService } from "../../../../services/LocationsMap.service";
import { PanelInternalLayerService } from "../../../../services/Panel-Internal-Layer.service";
import { PanelLocationsService } from "../../../../services/Panel-Locations.service";
import { CategoryFiltersDTO } from "src/app/features/shared/models/CategoryFilters/CategoryFilters";
import { FilterDefinition, FilterDialogData, FilterDialogResult, SelectedFilter} from "../../../../models/Filters";
import { MapRestrictionsService } from "src/app/features/pages/maps/services/MapRestrictions.service";
import { LocationsService } from "../../../../services/Locations.service";
import { DataNamesDTO } from "../../../../models/DataNamesDTO";
import { PopupCreateLocationComponent } from "src/app/features/map-features/ui/molecules/popup-create-location/popup-create-location.component";
import { PopupCreateVirtualLocationComponent } from "src/app/features/map-features/ui/molecules/popup-create-virtual-location/popup-create-virtual-location.component";
@Component({
  selector: "panel-locations",
  templateUrl: "./panel-locations.component.html",
  styleUrls: ["./panel-locations.component.css"],
  animations: [
    trigger("mostrarFiltro", [
      state("visible", style({ opacity: 1, height: "*" })),
      state("hidden", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("200ms ease-in-out")),
    ]),
    trigger("mostrarHerramientas", [
      state("visible", style({ opacity: 1, height: "*", minHeight: "*" })),
      state("hidden", style({ opacity: 0, height: "0px", minHeight: "0", overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("200ms ease-in-out")),
    ]),
  ],
})
export class PanelLocationsComponent implements OnInit, OnDestroy {

  dummyStatusFlags: StatusFlag[] = [
    { flagName: "En Movimiento", flagIcon: "icon_moving.png", priorityHex: "#4CAF50" },
    { flagName: "Batería Baja", flagIcon: "icon_battery_low.png", priorityHex: "#FFC107" },
    { flagName: "Desconectado", flagIcon: "icon_disconnected.png", priorityHex: "#F44336" },
  ];

  dummyFlagTypes: number[] = [1, 4, 6];

  allowedParts: AllowedDTO;
  
  @Output() onCardClickedEmitter: EventEmitter<any>;
  @Output() onCardFilterEmitter: EventEmitter<any>;

  //variables para los tab de la lista de locaciones
  @Input() $ItemsGet: LocationDTO[];
  @Input() $Items: LocationDTO[];
  itemsGetFilterRespaldo: LocationDTO[];
  itemsFilterRespaldo: LocationDTO[];
  $itemsFilterGlobal: { location: LocationDTO; tipo: string }[] = [];

  get globalFilterIdentifiers(): string[] {
    return this.$itemsFilterGlobal.map(item => item.location.identifier);
  }
  isLocationListEnd: boolean = false;
  isVisibleGPSTabs : boolean = true;
  hasGPSCategories: boolean = false;
  totalActualizados: string = "";
  totalDesactualizados: string = "";
  totalSinReporte: string = "";

  public isMapix: boolean = false;
  public isLoading: boolean = false;
  signalUser: SignalUser;
  fullScreen: boolean = false;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  //variables de buscador y herramientas
  showFilter: boolean = true;
  isToolButtonPressed: boolean = false;
  isSearchButtonPressed: boolean = true;
  globalFinder: string = "";
  signalIdentifier: string = "";

  //variables de filtro
  moduleSearch: string = "LocationSearch"; // todo cambiar a locationControlPanel
  filters: FilterDefinition[] = [];
  gpsFiltersSelected: SelectedFilter[] = [];
  filtersObject: FilterDialogData = { moduleName: "", filters: [], selected: [], idLocationCategory: null };
  ApplyFilter: boolean = false;
  isGlobalFilterActive: boolean = false;
  
  //variables de estado (que se encuentra seleccionado)
  selectedTabIndex: number = 1;
  excelDownloadOperation: string = "";
  private layerActivationTimeout: any = null;
  // selectedCategoryItem : LocationCategoryDTO;
  
  selectedCategoryTab: {category: LocationCategoryDTO, total:number, isVisible: boolean, filtersSelected: CategoryFiltersDTO[]} = null;
  categoriesTabs : {category: LocationCategoryDTO, total:number, isVisible: boolean, filtersSelected: CategoryFiltersDTO[]}[] = [];

  dialogRef: any;

  //variables de filtro de disponibilidad (de momento se dejaron de usar)
  // AvailabilityFiltersObject: { filters, selected, startDate, endDate, idLocationCategories };
  // availabilityFiltersSelected: any[] = [];
  // availabilityCateoriesSelected: number[] = [];
  // ApplyAvailabilityFilter: boolean = false;
  // availabilityInitialDate: Date = null;
  // availabilityFinalDate: Date = null;
  // availabilityFilter : boolean = false;

  suscription_postLocationsToExcel: Subscription;
  Subscription_AfterClosed: Subscription;
  subscription_GetFilters: Subscription;
  subscription_GetLoading: Subscription;
  subscription_GetList: Subscription;
  subscription_GetFiltroBase: Subscription;
  subscription_GetValuesFilters: Subscription;
  subscription_GetListFiltered: Subscription;
  subscription_findUpdatedByIdentifier: Subscription;
  subscription_GetCategoryList: Subscription;
  subscription_GetAllLocationsFilteredList: Subscription;
  subscription_GetSearch: Subscription;
  subscription_tabCategoryFiltersSelected: Subscription;
  subscription_GetTotalActualizado: Subscription;
  subscription_GetTotalDesactualizado: Subscription;
  subscription_GetTotalSinReporte: Subscription;
  subscription_SearchInput: Subscription;
  subscription_FindByIdentifier: Subscription;
  subscription_GetDataNames: Subscription;
  subscription_LocationDataChanged: Subscription;
  private subscriptionsFilter: Subscription[] = [];
  private searchSubject: Subject<string> = new Subject<string>();
  
  @ViewChild('filteredCategoryTab') filteredCategoryTabComponent: any;

  constructor(
    public panelLocationsService: PanelLocationsService,
    private router: Router,
    private sessionService: SessionService,
    private signalRService: SignalRService,
    private signalUserService: SignalUserService,
    private notificationsToastService: NotificationsToastService,
    public dialog: MatDialog,
    private filterMapService: FilterMapService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private locationsMapService: LocationsMapService,
    private panelInternalLayerService: PanelInternalLayerService,
    private tutorialService: TutorialService,
    private localStorageService: LocalStorageService,
    private mapRestrictionsService: MapRestrictionsService,
    private locationsService: LocationsService
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.onCardClickedEmitter = new EventEmitter<any>();
    this.onCardFilterEmitter = new EventEmitter<any[]>();
    this.signalUser = new SignalUser();

    this.subscription_GetLoading = this.panelLocationsService
      .getLoading()
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.subscription_GetSearch = this.panelLocationsService
      .getSearchData() .subscribe((data: string) => {
        this.globalFinder = data;

        if (this.globalFinder.length > 1)
          this.onGlobalFilter(this.globalFinder);
      });

    this.subscription_SearchInput = this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((searchValue: string) => {
      this.performSearch(searchValue);
    });

    this.subscription_tabCategoryFiltersSelected = this.panelLocationsService.tabCategoryFiltersSelected.pipe(
      filter(t => t != null && t.categoryToBeAffected != null)
    ).subscribe((selected) => {
      if (!this.selectedCategoryTab || selected.categoryToBeAffected.id != this.selectedCategoryTab.category.id) {
        return;
      }
      const layerFiltersSelected = selected.filters?.find(f => f.id == this.selectedCategoryTab.category.id.toString())?.filtersSelected ?? [];
      this.ApplyFilter = layerFiltersSelected.length > 0;
      this.filtersObject = { moduleName: this.selectedCategoryTab.category.filterModule || null, filters: [], selected: layerFiltersSelected, idLocationCategory: this.selectedCategoryTab.category.id };
    });

    this.panelLocationsService.setLoading(true);
    // this.panelLocationsService.setVisibilityPanel(true);

    //tras editar o crear una locación desde el detalle, se recarga el tab actual (lista y capa) forzando el bypass de cache para no mostrar datos desactualizados
    this.subscription_LocationDataChanged = this.panelLocationsService.getLocationDataChanged().subscribe(() => {
      this.isLocationListEnd = false;
      this.getLocations(1, true);
    });
  }

  ngOnInit(): void {
    this.allowedParts = this.mapRestrictionsService.allowedParts$.value;
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.checkingURL();
    this.GetCategories();
    // this.getLocations();
    if (this.isVisibleGPSTabs) {
      this.GetGPSTotals();
    }
    // this.panelInternalLayerService.clearLayers();
  }

  ngOnDestroy() {
    if (this.subscription_GetFilters)
      this.subscription_GetFilters.unsubscribe();
    if (this.subscription_GetList) this.subscription_GetList.unsubscribe();
    if (this.subscription_GetLoading)
      this.subscription_GetLoading.unsubscribe();
    if (this.subscription_GetFiltroBase)
      this.subscription_GetFiltroBase.unsubscribe();
    if (this.subscription_GetListFiltered)
      this.subscription_GetListFiltered.unsubscribe();
    if (this.subscription_GetValuesFilters)
      this.subscription_GetValuesFilters.unsubscribe();
    if (this.subscription_findUpdatedByIdentifier)
      this.subscription_findUpdatedByIdentifier.unsubscribe();
    if (this.subscription_GetCategoryList)
      this.subscription_GetCategoryList.unsubscribe();
    if (this.subscription_GetAllLocationsFilteredList)
      this.subscription_GetAllLocationsFilteredList.unsubscribe();
    if (this.subscription_GetSearch)
      this.subscription_GetSearch.unsubscribe();
    if (this.subscription_tabCategoryFiltersSelected)
      this.subscription_tabCategoryFiltersSelected.unsubscribe();
    if (this.subscription_GetTotalActualizado)
      this.subscription_GetTotalActualizado.unsubscribe();
    if (this.subscription_GetTotalDesactualizado)
      this.subscription_GetTotalDesactualizado.unsubscribe();
    if (this.subscription_GetTotalSinReporte)
      this.subscription_GetTotalSinReporte.unsubscribe();
    if (this.subscription_SearchInput)
      this.subscription_SearchInput.unsubscribe();
    if (this.subscription_FindByIdentifier)
      this.subscription_FindByIdentifier.unsubscribe();
    if (this.subscription_GetDataNames)
      this.subscription_GetDataNames.unsubscribe();
    if (this.subscription_LocationDataChanged)
      this.subscription_LocationDataChanged.unsubscribe();


    this.subscriptionsFilter.forEach((subscription) =>
      subscription.unsubscribe()
    );
    this.cancelPendingLayerActivation();
    this.panelInternalLayerService.clearFilterLayer();
    this.panelInternalLayerService.clearLayers();
    this.panelInternalLayerService.clearGPSLayer();
    
    if(this.dialogRef){
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }

  selectTab(event: any, resetLayers: boolean = true) {
    const previousTabIndex = this.selectedTabIndex;
    this.selectedTabIndex = Number(event.tab.textLabel);
    if(!environment.production) console.log("tab selected", event, event.tab.textLabel, this.categoriesTabs);
    //al cambiar de tab se limpian las capas seleccionadas 
    if (resetLayers) {
      this.cancelPendingLayerActivation();
      this.panelInternalLayerService.resetCategoryLayers();
      //entre tabs de gps la capa de activos filtrados muestra lo mismo, se conserva para no recargarla
      const isGPSTabSwitch = this.isGPSTab(previousTabIndex) && this.isGPSTab(this.selectedTabIndex);
      this.panelInternalLayerService.resetGPSLayers(!isGPSTabSwitch);
    }
    this.$Items = [];
    this.$ItemsGet = [];
    this.isLocationListEnd = false;
    this.unsubscribeTabs();
    this.unsubscribeFocusPin();
    this.getLocations();
  }

  //los primeros 3 tabs son los de gps (actualizados, desactualizados y sin reporte)
  isGPSTab(tabIndex: number): boolean {
    return tabIndex >= 1 && tabIndex <= 3;
  }

  unsubscribeTabs(){
    if (this.subscription_findUpdatedByIdentifier)
      this.subscription_findUpdatedByIdentifier.unsubscribe();
    if (this.subscription_GetList)
      this.subscription_GetList.unsubscribe();
    if (this.subscription_GetListFiltered)
      this.subscription_GetListFiltered.unsubscribe();
  }

  unsubscribeGlobalFilter(){
    if (this.subscription_GetAllLocationsFilteredList)
      this.subscription_GetAllLocationsFilteredList.unsubscribe();
  }

  unsubscribeFocusPin(){
    if (this.signalIdentifier.length > 0){
      this.locationsMapService.stopFocusPin();
      this.UnsubscribeSignalUser(this.signalUser);
    }
  }

  getLocations(page: number = 1, isForceReload: boolean = false) {
    this.panelLocationsService.setLoading(true);

    //default de tab gps, se cambiará si es de categoria
    this.showFilter = true;
    this.selectedCategoryTab = null;
    this.ApplyFilter = this.gpsFiltersSelected.length > 0;
    this.filtersObject = { moduleName: this.moduleSearch, filters: [], selected: this.gpsFiltersSelected, idLocationCategory: null };
    if (this.selectedTabIndex == 1) {
      this.excelDownloadOperation = "Actualizado";
      this.getLocationsActualizados(page);
    } else if (this.selectedTabIndex == 2) {
      this.excelDownloadOperation = "Desactualizado";
      this.getLocationsDesactualizados(page);
    } else if (this.selectedTabIndex == 3){
      this.excelDownloadOperation = "S/R";
      this.getLocationsSinReporte(page);
    } else{
      //se restan 4 porque en el label de las categorias se sumó a al label un 4 arbitrario. el objetivo de esta suma es que haya una convivencia entre tabs de categorias y de gps
      //los primeros 3 tabs son de funciones de gps y no llaman categoroias, el resto de tabs son de categorias y debe usarse su id
      this.selectedCategoryTab = this.categoriesTabs[this.selectedTabIndex -4];
      if (!this.selectedCategoryTab) {
        this.panelLocationsService.setLoading(false);
        return;
      }
      this.showFilter = !this.selectedCategoryTab.category.layerFilter_IsFiltered;

      if (this.selectedCategoryTab.category && this.selectedCategoryTab.category.layerFilter_IsFiltered) {
        const layerFiltersSelected = this.panelLocationsService.tabCategoryFiltersSelected.value.filters ?.find(f => f.id == this.selectedCategoryTab.category.id.toString())?.filtersSelected ?? [];
        this.ApplyFilter = layerFiltersSelected.length > 0;
        this.filtersObject = { moduleName: this.selectedCategoryTab.category.filterModule || null, filters: [], selected: layerFiltersSelected, idLocationCategory: this.selectedCategoryTab.category.id };
        if(!environment.production) console.log("selected category (layer filter)", this.selectedCategoryTab, layerFiltersSelected);
        if (layerFiltersSelected.length > 0) {
          this.ActivateLayer(this.selectedCategoryTab.category, layerFiltersSelected.map( filter => ({
            Key: filter.key,
            Value: filter.value,
            Module: filter.module || ''
          })), isForceReload);
        }
        this.panelLocationsService.setLoading(false);
        this.excelDownloadOperation = "Category";
        return;
      }

      this.ApplyFilter = this.selectedCategoryTab.filtersSelected.length > 0;
      const filstersSelected = this.selectedCategoryTab.filtersSelected.map( filter => { return { 
        key: filter.Key, 
        value: filter.Value, 
        display: filter.Value? filter.Value : filter.Key,
        module: this.selectedCategoryTab.category.filterModule || ''
      } });
      this.filtersObject = { moduleName: this.selectedCategoryTab.category.filterModule || null, filters: [], selected: filstersSelected, idLocationCategory: this.selectedCategoryTab.category.id };
      if(!environment.production) console.log("selected category", this.selectedCategoryTab, this.selectedTabIndex);

      this.panelLocationsService.setLoading(true);
      // this.excelDownloadOperation = this.selectedCategoryItem.id + 3;
      this.excelDownloadOperation = "Category";
      this.getLocationsByCategory(this.selectedCategoryTab.category, page, isForceReload);
    }
  }

  getLocationsActualizados(page: number) {
    if (this.gpsFiltersSelected.length < 1) {
      this.subscription_GetList = this.panelLocationsService
          .GetListActualizadosPage(page)
          .subscribe(
            (data: EstatusJSON) => {
              if (data.isSuccess == true) {
                this.totalActualizados = data.result.contador.toString();
                this.setLocationList(data, page);
                if(!environment.production) console.log("Actualizados", this.$Items);
              } else {
                Sentry.captureMessage('PanelLocations.getLocationsActualizados: respuesta sin éxito', { level: 'warning', extra: { response: data } });
              }
            },
            (error) => {
              // this.notificationsToastService.showErrorSystem();
              console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
              this.panelLocationsService.setLoading(false);
              return false;
            }
          );
      this.panelInternalLayerService.ActivateGPSLayer(EnumPanelGPSTabTypes.Actualizados);
    } else {
      this.getFilterGPSTab("Actualizado", this.globalFinder);
    }
  }

  getLocationsDesactualizados(page: number) {
    if (this.gpsFiltersSelected.length < 1) {
      this.subscription_GetList = this.panelLocationsService
          .GetListDesactualizadosPage(page)
          .subscribe(
            (data: EstatusJSON) => {
              if (data.isSuccess == true) {
                this.totalDesactualizados = data.result.contador.toString();
                this.setLocationList(data, page);
                if(!environment.production) console.log("Desactualizados", data, this.$Items);

              } else {
                Sentry.captureMessage('PanelLocations.getLocationsDesactualizados: respuesta sin éxito', { level: 'warning', extra: { response: data } });
              }
            },
            (error) => {
              //Error callback
              // this.notificationsToastService.showErrorSystem();
              console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
              this.panelLocationsService.setLoading(false);
              return false;
            }
          );
      this.panelInternalLayerService.ActivateGPSLayer(EnumPanelGPSTabTypes.Desactualizados);
    } else {
      this.getFilterGPSTab("Desactualizado", this.globalFinder);
    }
    //this.locations.GetLocations();
  }

  getLocationsSinReporte(page: number) {
    if (this.gpsFiltersSelected.length < 1) {
      this.subscription_GetList = this.panelLocationsService.GetListSinReportePage(page)
          .subscribe(
            (data: EstatusJSON) => {
              if (data.isSuccess == true) {

                this.totalSinReporte = data.result.contador.toString();
                this.setLocationList(data, page);
                if(!environment.production) console.log("S/R", this.$Items);
              } else {
                Sentry.captureMessage('PanelLocations.getLocationsSinReporte: respuesta sin éxito', { level: 'warning', extra: { response: data } });
              }
            },
            (error) => {
              //Error callback
              // this.notificationsToastService.showErrorSystem();
              console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
              this.panelLocationsService.setLoading(false);
              return false;
            }
          );
      this.panelInternalLayerService.ActivateGPSLayer(EnumPanelGPSTabTypes.SinReporte);
        //this.locations.GetLocations();
    } else {
      this.getFilterGPSTab("S/R", this.globalFinder);
    }
  }

  // --------------- tabs de categories --------------

  getLocationsByCategory(category: LocationCategoryDTO, page: number, isForceReload: boolean = false) {
    if(!environment.production) console.log("get by idcategory", category);
    //&& !this.ApplyAvailabilityFilter
    if (!this.ApplyFilter ) {
      this.ActivateLayer(this.selectedCategoryTab.category, [], isForceReload);
        this.subscription_GetList = this.panelLocationsService.GetListNamesFilterByIdLocationCategoryPage(category.id, page)
          .subscribe(
            (data: EstatusJSON) => {
              if (data.isSuccess == true) {
                this.categoriesTabs.find( cat =>cat.category.id == category.id ).total = data.result.contador;
                this.setLocationList(data, page);
                if(!environment.production) console.log("get by idcategory response", this.$Items, data.result);
              } else {
                const cat = this.categoriesTabs.find( cat => cat.category.id == category.id );
                if (cat) cat.total = 0;
                this.panelLocationsService.setLoading(false);
                Sentry.captureMessage('PanelLocations.getLocationsByCategory: respuesta sin éxito', { level: 'warning', extra: { response: data, categoryId: category.id } });
              }
            },
            (error) => {
              // this.notificationsToastService.showErrorSystem();
              console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
              this.panelLocationsService.setLoading(false);
              return false;
            }
          );
    } else {
      if (this.ApplyFilter) {
        this.ActivateLayer(this.selectedCategoryTab.category, this.selectedCategoryTab.filtersSelected, isForceReload);
        const categoryFilters = this.categoriesTabs.find( cat => cat.category.id == category.id )?.filtersSelected || [];
        // this.subscription_GetListFiltered = this.panelLocationsService.getListFilterTab( categoryFilters, "Category", "", category.id )
        this.subscription_GetListFiltered = this.panelLocationsService.GetListByIdLocationCategoryPage(category.id, page, categoryFilters )
        .subscribe(
          (data: EstatusJSON) => {
            if (data.isSuccess == true) {
                this.categoriesTabs.find( cat =>cat.category.id == category.id ).total = data.result.contador;
                this.setLocationList(data, page);
                if(!environment.production) console.log("get by idcategory response", this.$Items, data.result);
              } else {
                const cat = this.categoriesTabs.find( cat => cat.category.id == category.id );
                if (cat) cat.total = 0;
                this.panelLocationsService.setLoading(false);
                Sentry.captureMessage('PanelLocations.getLocationsByCategory: respuesta sin éxito', { level: 'warning', extra: { response: data, categoryId: category.id } });
              }


            // if(!environment.production) console.log("filtro actualizado", data.result);
            // this.$Items = data.result;
            // this.$ItemsGet = this.$Items;
            // this.panelLocationsService.setLoading(false);
          },
          (error) => {
            //Error callback
            // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
            this.panelLocationsService.setLoading(false);
            return false;
          }
        );
      }else{
        // this.subscription_GetListFiltered = this.panelLocationsService
        //   .GetListAvailabilityFilterByLocationCategory(
        //     this.availabilityFiltersSelected,
        //     this.availabilityInitialDate.toISOString(),
        //     this.availabilityFinalDate.toISOString(),
        //     [this.selectedCategoryItem.id]
        //   )
        //   .subscribe(
        //     (data: EstatusJSON) => {
        //       if(!environment.production) console.log("filtro de disponibilidad", data.result);

        //       this.panelLocationsService.setLoading(false);
        //       this.$Items = data.result;
        //       this.$ItemsGet = this.$Items;
        //       this.ApplyAvailabilityFilter = true;
        //       this.categoriesTabs.find( cat =>cat.category.id == category.id ).total = data.result.length
        //     },
        //     (error) => {
        //       //Error callback
        //       this.panelLocationsService.setLoading(false);
        //       return false;
        //     }
        //   );
      }

    }
  }

  getFilterGPSTab(tipoTab: string, identificadorFinder: string) {
    //la capa de activos filtrados no depende del tab de gps, solo se carga si aún no tiene esos filtros
    if (!this.panelInternalLayerService.isGPSFilteredLayerLoaded(this.gpsFiltersSelected))
      this.panelInternalLayerService.activateGPSFilteredLayer(this.gpsFiltersSelected);
    this.subscription_GetListFiltered = this.panelLocationsService.getListFilterTab(this.gpsFiltersSelected, tipoTab, identificadorFinder, this.selectedCategoryTab?.category?.id || 0)
      .subscribe(
      (data: EstatusJSON) => {
        if(!environment.production) console.log("filtro ", data.result);
          if (data.isSuccess == false || data.result == null) {
            Sentry.captureMessage('PanelLocations.getFilterGPSTab: respuesta sin éxito', { level: 'warning', extra: { response: data, tipoTab } });
            this.$Items = [];
            this.$ItemsGet = this.$Items;
            this.setGPSTabTotal(tipoTab, 0);
            this.panelLocationsService.setLoading(false);
            return;
          }
          this.$Items = (data.result.listaLocaciones || []) as LocationDTO[];
          this.$Items.forEach(item => {
            item.panelIcon = item.icon;
          });
          this.$ItemsGet = this.$Items;
          this.setGPSTabTotal(tipoTab, data.result.contador ?? this.$Items.length);
          this.panelLocationsService.setLoading(false);
        },
      (error) => {
        //Error callback
        // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
        this.panelLocationsService.setLoading(false);
        return false;
      }
    );
  }

  setGPSTabTotal(tipoTab: string, total: number) {
    switch (tipoTab) {
      case "Actualizado":
        this.totalActualizados = total.toString();
        break;
      case "Desactualizado":
        this.totalDesactualizados = total.toString();
        break;
      case "S/R":
        this.totalSinReporte = total.toString();
        break;
    }
  }

  // getLocationFilter(selectedCategorY: number = null) {
  //   //!this.availabilityFilter
  //   if (true) {
  //     if(!environment.production) console.log("GetLocationsListFiltered");
  //     if (!this.ApplyFilter) {
  //       this.itemsFilterRespaldo = this.$Items;
  //       this.itemsGetFilterRespaldo = this.$ItemsGet;
  //     }
  //     this.subscription_GetListFiltered = this.panelLocationsService.getListFilter(this.filtersSelected)
  //       .subscribe(
  //         (data: EstatusJSON) => {
  //           this.panelLocationsService.setLoading(false);
  //           this.$Items = this.itemsFilterRespaldo.filter((item) =>
  //             data.result.some(
  //               (argItem) => argItem.identifier === item.identifier
  //             )
  //           );
  //           this.$ItemsGet = this.$Items;
  //           this.ApplyFilter = true;
  //         },
  //         (error) => {
  //           //Error callback
  //           // this.notificationsToastService.showErrorSystem();
  //       console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
  //           this.panelLocationsService.setLoading(false);
  //           return false;
  //         }
  //       );
  //   }else{
  //     // this.subscription_GetListFiltered = this.panelLocationsService
  //     //     .GetListAvailabilityFilterByLocationCategory(
  //     //       this.availabilityFiltersSelected,
  //     //       this.availabilityInitialDate.toISOString(),
  //     //       this.availabilityFinalDate.toISOString(),
  //     //       [selectedCategorY]
  //     //     )
  //     //     .subscribe(
  //     //       (data: EstatusJSON) => {
  //     //         if(!environment.production) console.log("filtro de disponibilidad", data.result);

  //     //         this.panelLocationsService.setLoading(false);
  //     //         this.$Items = data.result;
  //     //         this.$ItemsGet = this.$Items;
  //     //         this.categoriesTabs.find( cat =>cat.category.id == selectedCategorY ).total = data.result.length;
  //     //       },
  //     //       (error) => {
  //     //         //Error callback
  //     //         this.panelLocationsService.setLoading(false);
  //     //         return false;
  //     //       }
  //     //     );
  //   }

  // }

  setLocationList(data: any, page : number) {
    
    if(this.isLocationListEnd){
      this.panelLocationsService.setLoading(false);
      return;
    }

    const locationList = data.result.listaLocaciones as LocationDTO[];

    // si ya no hay datos, se termina la busqueda
    if (locationList.length == 0) {
      this.isLocationListEnd = true;
      var empty = new Array<LocationDTO>();
      this.setLocationPage(empty, page);
      return;
    }

    // si hay menos de 20 elementos, se asignan los que hay y termina la busqueda
    if (locationList.length < 20) {
      this.isLocationListEnd = true;
      this.setLocationPage(locationList, page);
      return;
    }

    this.setLocationPage(locationList, page);
  }

  setLocationPage(result: LocationDTO[], page: number) {
    result.forEach(item => {
      item.panelIcon = item.icon;

      // item.flagTypes = this.dummyFlagTypes;

      item.statusFlags = item.statusFlags || [];
      item.statusFlags.push(...this.getStatusFlagsByFlagTypes(item.flagTypes));
    });
    if(page == 1){
      this.$Items = result;
      this.$ItemsGet = this.$Items;
    }

    if(page != 1){
      this.$Items = this.$Items.concat(result);
      this.$ItemsGet = this.$Items;
    }

    this.panelLocationsService.setLoading(false);
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  onCardClicked(locationSelected: any) {
    console.log("selected", locationSelected);
    
    var elemento: LocationDTO;
    if (this.isGlobalFilterActive) {
      this.$itemsFilterGlobal.forEach((element) => {
        if (element.location == locationSelected) {
          elemento = element.location;
        }
      });
    } else {
      this.$Items.forEach((element) => {
        if (element == locationSelected) {
          elemento = element;
        }
      });
    }

    const selectedLocation = elemento != null ? elemento : locationSelected;
    //Add Client to SignalHub
    this.signalUser.Identifier = selectedLocation.identifier;
    this.SubscribeSignalUser(this.signalUser);

    //Emit event
    this.signalIdentifier = selectedLocation.identifier;
    var location = { identifier: selectedLocation.identifier, idLocationCategory: selectedLocation.idLocationCategory };
    this.onCardClickedEmitter.emit(location);
    if(!environment.production) console.log("Emitter Enfoque Pin, " + elemento);
    //Reset filter
    if(!environment.production) console.log("reset filter...");
    if (!this.isGlobalFilterActive) {
      this.$Items = this.$ItemsGet.slice();
    }
  }

  SubscribeSignalUser(SignalUser: SignalUser) {
    //Subscribe to SignalClient
    SignalUser.ConnectionId = this.signalRService.ConnectionId;
    this.fullScreen = false;
    this.signalUserService.SubscribeIdentifierSignalUserService(SignalUser);
    this.signalRService.ActivateListenerUpdateLocationActive(SignalUser.Identifier);
  }

  UnsubscribeSignalUser(SignalUser: SignalUser) {
    //Subscribe to SignalClient
    SignalUser.ConnectionId = this.signalRService.ConnectionId;
    this.signalRService.DeactivateListenerUpdateLocationActive(this.signalIdentifier);
    this.signalUserService.UnsubscribeSignalUserIdentifierService(this.signalIdentifier);
    this.signalIdentifier = "";
  }

  filterResponse(res: FilterDialogResult): void {
      if (res.search) {
        if(!environment.production) console.log("Filtro de búsqueda activado", res);
        this.panelLocationsService.setLoading(true);

        if (res.filtersSelected.length > 0) {
          // this.GetGPSTotals();
          // this.GetCategoriesTotals(true);
          if(res.idLocationCategory != null){
            const filtersSelected: CategoryFiltersDTO[] = res.filtersSelected.map(filter => {
              return {
                Key: filter.key,
                Value: filter.value,
                Module: filter.module || ''
              }
            });
            const tab = this.categoriesTabs.find( cat => cat.category.id == res.idLocationCategory );
            if (tab) 
              tab.filtersSelected = filtersSelected;
          }else{
            this.gpsFiltersSelected = res.filtersSelected;
          }
          this.isLocationListEnd = false;
          this.getLocations();
        } else {
          this.unsubscribeTabs();
          if(res.idLocationCategory != null){
            const tab = this.categoriesTabs.find( cat => cat.category.id == res.idLocationCategory );
            if (tab) 
              tab.filtersSelected = [];
          }else{
            this.gpsFiltersSelected = [];
          }
          this.isLocationListEnd = false;
          // this.GetGPSTotals();
          // this.GetCategoriesTotals(false);
          this.panelLocationsService.setLoading(false);
          this.getLocations();
        }
        
        //las capas de gps solo se tocan si el tab actual es de gps, en un tab de categoria el filtro
        if (this.isGPSTab(this.selectedTabIndex)) {
          if (this.gpsFiltersSelected.length == 0) {
            if (this.mapRestrictionsService.isGPSAllowed() || this.allowedParts.allowedCategories.length === 0) {
              this.panelInternalLayerService.reloadGPSLayer();
            }
            this.panelInternalLayerService.clearFilterLayer();
          } else {
            if (this.mapRestrictionsService.isGPSAllowed() || this.allowedParts.allowedCategories.length === 0){
              //getLocations ya la cargó desde getFilterGPSTab, esto solo cubre el caso de que no haya pasado por ahí
              if (!this.panelInternalLayerService.isGPSFilteredLayerLoaded(this.gpsFiltersSelected))
                this.panelInternalLayerService.activateGPSFilteredLayer(this.gpsFiltersSelected);
              this.panelInternalLayerService.clearGPSLayer();
            }
          }
        }
      }
  }

  // availabilityFilterResponse(res: any): void {
  //   if(!environment.production) console.log("disponibilidad respuesta", res);

  //     if (res.search) {
  //       this.panelLocationsService.setLoading(true);
  //       if (res.initialDate != null && res.finalDate  != null) {
  //         if(!environment.production) console.log("AVA res", res);

  //         this.availabilityFiltersSelected = res.filtersSelected;
  //         this.availabilityInitialDate = res.initialDate;
  //         this.availabilityFinalDate = res.finalDate;
  //         this.availabilityCateoriesSelected = res.selectedCategories;
  //         this.isVisibleGPSTabs = res.isVisibleGPSTabs;
  //         this.availabilityFilter = true;
  //         this.AvailabilityFiltersObject = {filters: this.filters, selected: this.filtersSelected, startDate: this.availabilityInitialDate, endDate: this.availabilityFinalDate, idLocationCategories: this.availabilityCateoriesSelected};

  //         this.categoriesTabs.forEach(cat => {
  //           cat.isVisible = true;
  //           if (!this.availabilityCateoriesSelected.includes(cat.category.id)) {
  //             cat.isVisible = false;
  //           }
  //         });
  //         if (this.isVisibleGPSTabs) {
  //           this.getLocationFilter();
  //         }else{
  //           var visibleCategoriesArray : number[] = [];
  //           if (this.selectedCategoryItem == null) {
  //             visibleCategoriesArray = this.categoriesTabs.filter(cat => cat.isVisible).map(cat => cat.category.id);
  //           }else{
  //             visibleCategoriesArray.push(this.selectedCategoryItem.id);
  //           }
  //           this.panelInternalLayerService.DeactivateAllLayers();
  //           this.panelInternalLayerService.onToggleLayerActivos(false);
  //           this.panelInternalLayerService.onToggleLayerFiltros(true);
  //           this.getLocationFilter(visibleCategoriesArray[0]);
  //         }

  //         this.ApplyAvailabilityFilter = true;
  //       }else{
  //         this.unsubscribeTabs();
  //         this.availabilityFiltersSelected = [];
  //         this.availabilityInitialDate = null;
  //         this.availabilityFinalDate = null;
  //         this.AvailabilityFiltersObject = {filters: this.filters, selected: this.filtersSelected, startDate: this.availabilityInitialDate, endDate: this.availabilityFinalDate, idLocationCategories: null};
  //         this.ApplyAvailabilityFilter = false;
  //         this.availabilityFilter = false;

  //         this.isVisibleGPSTabs = true;
  //         this.availabilityCateoriesSelected = null;
  //         this.categories.forEach(cat => {
  //           cat.isVisible = true;
  //         });
  //         this.mapHelperService.UpdateLayerGeoJson(
  //           "filterPointsSource",
  //           this.mapHelperService.Empty_GeoJson
  //         );
  //         this.panelInternalLayerService.onToggleLayerActivos(true);
  //           this.panelInternalLayerService.onToggleLayerFiltros(false);
  //         this.getLocations();
  //         this.panelLocationsService.setLoading(false);
  //       }

  //       const filters = { normalFilter: null, availabilityFilter: this.AvailabilityFiltersObject };
  //       this.onCardFilterEmitter.emit(filters);
  //     }
  // }

  onGlobalFilterButton(event){
    if (event > 0) {
      this.performSearch(event);
    }
    else{
      return;
    }
  }

  onSearchInput(value: string) {
    this.searchSubject.next(value);
  }

  private performSearch(event: string) {
    this.onGlobalFilter(event);
  }

  onGlobalFilter(event) {
    if (!this.mobileQuery.matches) {
      this.fullScreen = true;
    }
    this.$itemsFilterGlobal = [];
    if (event.length > 0) {
      this.isLoading = true;
      this.isGlobalFilterActive = true;

      // Cancelar las suscripciones anteriores
      // this.subscriptionsFilter.forEach((subscription) =>
      //   subscription.unsubscribe()
      // );
      // this.subscriptionsFilter = [];

      this.unsubscribeGlobalFilter();
      this.unsubscribeFocusPin();
      this.unsubscribeTabs();
      // Agregar busquedas como subscripciones para después detener
      this.subscription_GetAllLocationsFilteredList = this.panelLocationsService.FindAllByIdentifier(event).subscribe({
        next: (data: any) => {
          if (data.isSuccess == false) {
            // this.notificationsToastService.showErrorSystem();
          Sentry.captureMessage('PanelLocations.FindAllByIdentifier: respuesta sin éxito', { level: 'warning', extra: { event, response: data } });
          console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
            this.isLoading = false;
            return;
          }

          if(!environment.production) console.log("FindAllByIdentifier", data.result);
          const gpsTypes = ['Actualizado', 'Desactualizado', 'Desconectado'];
          this.$itemsFilterGlobal = (data.result as any[]).filter(item => {
            if (gpsTypes.includes(item.tipo)) {
              return this.allowedParts.allowedCategories.includes('gps');
            }
            return this.allowedParts.allowedCategories.includes(item.location?.idLocationCategory?.toString());
          });

          this.$itemsFilterGlobal.forEach((item) => {
            item.location.panelIcon = item.location.icon;
            
            // item.location.flagTypes = this.dummyFlagTypes;

            item.location.statusFlags = item.location.statusFlags || [];
            item.location.statusFlags.push(...this.getStatusFlagsByFlagTypes(item.location.flagTypes));
          });
          this.isLoading = false;
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error al buscar locaciones por identificador', error);
          // this.notificationsToastService.showErrorSystem();
        console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
          this.isLoading = false;
        }
      });
    } else {
      this.isGlobalFilterActive = false;
      this.isLoading = false;
      this.resetTabs();
    }
  }

  GetCategories(){
    try{
      const categories = JSON.parse(this.localStorageService.getListaCategorias()) as LocationCategoryDTO[];
      this.hasGPSCategories = categories.some(category => category.itWorksAsGPS);
      this.isVisibleGPSTabs = this.hasGPSCategories && this.allowedParts?.allowedCategories?.includes("gps");

      const specialCategoryNames: string[] = [EnumLocationCategories.Location, EnumLocationCategories.Service];
            
      categories.filter(cat => cat.itWorksAsGPS == false && cat.canBeShownInPanel).forEach(cat=> {
        var total = 0;
        if (cat.total != null) {
          total = cat.total;
        }
        this.categoriesTabs.push({ category: cat, total: total, isVisible: true, filtersSelected: [] });
      });
      this.categoriesTabs.forEach(cat => {
        cat.category.panelIcon = cat.category.icon;
      });
  
      this.resetTabs();
    }catch(error){
      if(!environment.production) console.log(error);
    }
  }

  resetTabs(){
    if (!this.isVisibleGPSTabs && this.categoriesTabs.length > 0) {
      const firstAllowedIndex = this.categoriesTabs.findIndex(cat =>
        this.allowedParts?.allowedCategories.includes(cat.category.id.toString())
      );
      if (firstAllowedIndex >= 0) {
        this.selectedTabIndex = firstAllowedIndex + 4;
        this.selectTab({ tab: { textLabel: this.selectedTabIndex } }, false);
      } else {
        this.panelLocationsService.setLoading(false);
      }
    }else{
      this.selectedTabIndex = 1;
      this.selectTab({ tab: { textLabel: this.selectedTabIndex } }, false);
    }
  }

  GetGPSTotals(){
    try{
      // this.subscription_GetTotalActualizado = this.panelLocationsService.GetCountListActualizados(this.filtersObject.selected).subscribe({
      //   next: (data: EstatusJSON) => {
      //     if (data.isSuccess == true) {
      //         this.totalActualizados = data.result.toString();
      //       }else{
      //         this.totalActualizados = "0";
      //         console.error('Error al obtener total actualizados', data.message);
      //       }
      //     },
      //   error: (error) => {
      //     // TODO marca para complete despues
      //     console.error('Error al obtener total actualizados', error);
      //     // this.notificationsToastService.showErrorSystem();
      //   console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
      //   }
      // });

      // this.subscription_GetTotalDesactualizado = this.panelLocationsService.GetCountListDesactualizados(this.filtersObject.selected).subscribe({
      //   next: (data: EstatusJSON) => {
      //       if (data.isSuccess == true) {
      //         this.totalDesactualizados = data.result.toString();
      //       }else{
      //         this.totalDesactualizados = "0";
      //         console.error('Error al obtener total desactualizados', data.message);
      //       }
      //     },
      //   error: (error) => {
      //     // TODO marca para complete despues
      //     console.error('Error al obtener total desactualizados', error);
      //     // this.notificationsToastService.showErrorSystem();
      //   console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
      //   }
      // });

      // this.subscription_GetTotalSinReporte = this.panelLocationsService.GetCountListSinReporte(this.filtersObject.selected).subscribe({
      //   next: (data: EstatusJSON) => {
      //     if (data.isSuccess == true) {
      //       this.totalSinReporte = data.result.toString();
      //     }else{
      //       this.totalSinReporte = "0";
      //       console.error('Error al obtener total sin reporte', data.message);
      //     }
      //   },
      //   error: (error) => {
      //     // TODO marca para complete despues
      //     console.error('Error al obtener total sin reporte', error);
      //     // this.notificationsToastService.showErrorSystem();
      //   console.error("Servicio no disponible, contacte al administrador o inténtelo más tarde: Falla al conectar con el servidor");
      //   }
      // });
    }catch(error){
      if(!environment.production) console.log(error);
    }
  }

  async GetCategoriesTotals(hasFilter: boolean){
    try{
      if (hasFilter) {
        for (let category of this.categoriesTabs){
          const resp = await firstValueFrom(this.panelLocationsService.GetCountByIdLocationCategory(category.category.id, this.filtersObject.selected));
          if(resp.isSuccess)
            category.total = resp.result;
        }
      }else{
        const categories = JSON.parse(this.localStorageService.getListaCategorias()) as LocationCategoryDTO[];
        this.categoriesTabs.forEach(category => {
          var originalCategory = categories.find( originalCat => originalCat.id == category.category.id);
          category.total = originalCategory ? originalCategory.total : 0 ;
        });
      }
      
    }catch(error){
      if(!environment.production) console.log(error);
    }
  }

  cancelPendingLayerActivation(){
    if (this.layerActivationTimeout != null) {
      clearTimeout(this.layerActivationTimeout);
      this.layerActivationTimeout = null;
    }
  }

  ActivateLayer(category: LocationCategoryDTO, filtersApplied: CategoryFiltersDTO[], isForceReload: boolean = false){
    var systemLayer = new LayerDTO();
    systemLayer.name = category.shortName;
    systemLayer.categoryId = category.id;
    if(!environment.production) console.log("capas panel", this.panelInternalLayerService.capas$.value, filtersApplied);
    this.layerActivationLoop(systemLayer, filtersApplied, isForceReload);
  }

  layerActivationLoop(layer: LayerDTO, filtersApplied: CategoryFiltersDTO[], isForceReload: boolean = false, attempts: number = 0): void {
    const maxAttempts = 5;
    const delay = 2000;
    while (attempts < maxAttempts) {
      const foundLayer = this.panelInternalLayerService.capas$.value.find(capa => capa.categoryId === layer.categoryId);
      if (foundLayer) {
        this.panelInternalLayerService.ActivateLayer(layer, filtersApplied, isForceReload);
        break;
      } else {
        attempts++;
        this.layerActivationTimeout = setTimeout(() => {
          this.layerActivationTimeout = null;
          this.layerActivationLoop(layer, filtersApplied, isForceReload, attempts);
        }, delay);
        break;
      }
    }
  }

  ClosePanel(){
    this.fullScreen = false;
    this.panelLocationsService.setVisibilityPanel(false);
    this.panelLocationsService.setSearchVisibility(true);
  }

  onScroll(event: any): void {
    console.log("scroll", event);
    
    if(this.isLocationListEnd || this.isLoading){
      return;
    }

    if (this.gpsFiltersSelected.length > 0){
      return;
    }
    const element = event.target;
    if (element.scrollHeight - element.scrollTop <= (element.clientHeight + 10)) {
      this.loadMoreLocations();
    }
  }

  onScrollUbicacion(event: any): void {
    const filteredCategoryTabComponent = this.filteredCategoryTabComponent;
    if (filteredCategoryTabComponent) {
      filteredCategoryTabComponent.onScroll(event);
    }
  }

  loadMoreLocations(): void {
    this.panelLocationsService.setLoading(true);
    // se obtiene la página de tal forma que si hay números residuales, se vuelva a pedir desde la página con los residuos incluidos, para evitar lapsos
    var page = 0;
    var length = this.$Items.length;
    var residue = length % 20;
    if (residue != 0) {
      page = Math.floor(length / 20);
      // si el numero de residuo es mayor a 0 pero el total menor a 10, dará 0, se suma 1 a la página para que se pida desde la primera
      if(page < 1){
        page = 1;
      }
    }else{
      page = (length / 20) + 1;
    }
    if(!environment.production) console.log('page', length, residue, page);
    this.getLocations(page);
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.notificationsToastService.showSuccess("Texto copiado al portapapeles", text);
  }

  resetGlobalFilterValue(): void {
    this.globalFinder = '';
    this.onGlobalFilter(this.globalFinder);
  }

  getStatusFlagsByFlagTypes(flagTypes: number[]) : StatusFlag[] { 
    var statusFlags = [];
    if (flagTypes == null || flagTypes.length < 1) {
      return statusFlags;
    }
    flagTypes.forEach(flagType => {
      var statusKey = Object.keys(EnumAlarmCategory).find(key => EnumAlarmCategory[key] === flagType);
      if(!environment.production) console.log("statusKey", statusKey, EnumAlarmCategoriesValues[statusKey], EnumAlarmCategoriesColors[statusKey]);
      
      if (statusKey) {
        var statusFlag = { flagName: EnumAlarmCategoriesValues[statusKey], priorityHex: EnumAlarmCategoriesColors[statusKey], flagIcon: EnumAlarmCategoriesIcons[statusKey] } as StatusFlag;
        statusFlags.push(statusFlag);
      }else{
        return null;
      }
    });
    return statusFlags;
  }

  updateCategoryTotal({id, total}: {id: number, total: number}): void {
    var category = this.categoriesTabs.find(cat => cat.category.id === id);
    if (category) {
      category.total = total;
    }
  }

  openCreateLocationDialog(category: LocationCategoryDTO, items: LocationDTO[]) {
    if (this.isLoading) 
      return;
    this.panelLocationsService.setLoading(true);
    const firstIdentifier = items && items.length > 0 ? items[0].identifier : null;
    if (!firstIdentifier) {
      this.openCreatePopup(category, [], []);
      return;
    }

    this.subscription_FindByIdentifier = this.locationsService.getByIdentifier(firstIdentifier).subscribe({
      next: (data: EstatusJSON) => {
        if (data?.isSuccess && data.result) {
          
          const templateGroups = { idGroup: data.result.idGroup ?? 0, idSubGroup: data.result.idSubGroup ?? 0 };

          const templateEntries: any[] = Object.values(data.result.data || {});
          const templateKeys: string[] = templateEntries.map((entry) => entry.key).filter((key) => !!key);

          if (templateKeys.length === 0) {
            this.openCreatePopup(category, [], [], templateGroups);
            return;
          }

          this.subscription_GetDataNames = this.locationsService.getDataNames(templateKeys.concat([category.name])).subscribe({
            next: (namesData: EstatusJSON) => {
              const keyNames: DataNamesDTO[] = namesData?.isSuccess ? namesData.result : [];
              this.openCreatePopup(category, templateKeys, keyNames, templateGroups);
            },
            error: () => this.openCreatePopup(category, templateKeys, [], templateGroups)
          });
        } else {
          this.openCreatePopup(category, [], []);
        }
      },
      error: () => this.openCreatePopup(category, [], [])
    });
  }

  private openCreatePopup(category: LocationCategoryDTO, keys: string[], keyNames: DataNamesDTO[], groups: { idGroup: number, idSubGroup: number } = { idGroup: 0, idSubGroup: 0 }) {
    this.panelLocationsService.setLoading(false);
    if(category.itWorksAsVirtualLocation){
        this.dialogRef = this.dialog.open(PopupCreateVirtualLocationComponent, {
        maxWidth: "98vw",
        maxHeight: "92vh",
        autoFocus: false,
        restoreFocus: false,
        hasBackdrop: false,
        disableClose: true,
        data: { category, keys, keyNames, groups, mobileQuery: this.mobileQuery }
      });
    }else{
      this.dialogRef = this.dialog.open(PopupCreateLocationComponent, {
        maxWidth: "98vw",
        maxHeight: "92vh",
        autoFocus: false,
        restoreFocus: false,
        hasBackdrop: false,
        disableClose: true,
        data: { category, keys, keyNames, groups, mobileQuery: this.mobileQuery }
      });
    }
    

    this.dialogRef.afterClosed().subscribe((result) => {
      if (result?.isCreated && this.selectedCategoryTab?.category?.id === category.id) {
        //vuelve a pedir el tab del panel (lista) y la capa del tab para reflejar la ubicación recién creada
        this.getLocations();
        if (category.layerFilter_IsFiltered) {
          const current = this.panelLocationsService.tabCategoryFiltersSelected.value;
          this.panelLocationsService.tabCategoryFiltersSelected.next({ filters: current.filters, categoryToBeAffected: category });
        }
      }
      this.dialogRef = null;
    });
  }
}
